module.exports = __webpack_public_path__ + "static/wjc-2b2d81a855a78052a74d932831a53d61.png";